module.exports = __webpack_public_path__ + "img/file-lock2.c14cf7cd.svg";